import { NextRouter } from 'next/router'

const places: Record<string, string> = {
  events: 'event',
  hospitals: 'hospital',
  search: 'search_result',
  treatments: 'treatment',
  posts: 'column',
}

/**
 * pathname에 해당하는 place(노출된 화면)을 리턴한다
 * 여기서 place는 모듈(이벤트/병원/후기 등)이 노출된 화면을 의미한다
 * @param router NextRouter
 * @returns
 */
export const getPlaceByPathname = (router: NextRouter): string => {
  const path = router.pathname.split('/')[2]
  return places[path] || ''
}

export * from './amplitude-service'
